<img directive-image-preload [ngStyle]="{'width': imgWidth, 'height': imgWidth && 'auto'}"
    [hidden]="loading || !src || invisible" [url]="src" [alt]="alt" class="square-image" *ngIf="src"
    [ngClass]="{'-icon': icon}" (onLoaded)="handleOnLoaded($event)">
<shared-loader-for-placeholder *ngIf="loading || !src || invisible" class="square-image__loader">
</shared-loader-for-placeholder>